import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class IncidentDescription extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'incidentDescription'}
            title={ t('support.procedure.P19.title') }
            exportTitle={ t('support.procedure.P19.exportTitle') }
            exportFileName={'incident_description.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (IncidentDescription);
